module.exports = {"apiURL":"https://omni-api.supernova.inc/rest/v1","testMode":false,"redirectOnError":true};